<template>
    <b-overlay :show="showoverlay" rounded="sm">
    <div>
        <div class="atlhr-pf-wizard">
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>

       
        <div class="row no-gutters py-2 mb-3 ml-3">
			<div class="col-sm-6 pr-3 ">
				<h4 class="atlhr-dashboard-title mt-10">
					<span class="blue-title"></span>Provident Fund Management
					<span>
						<a v-bind:href="pageurl">Dashboard</a>
						/ Provident Fund Management
					</span>
				</h4>
			</div>
		</div>
        
        <div class="mt-4 employee-tab row no-gutters py-2 mb-3 ml-3">
            
            <b-tabs v-model="ewtabIndex" pills content-class="" nav-class="justify-content-left pr-2 m-2" nav-wrapper-class="col-md-9 custom-margin custom-tab-nav ml-auto pl-0">
                                
                <template v-if="ce">

                    <b-tab lazy>
                        
                        <template active v-slot:title>Summary</template>                
                        <div class="clearfix">
                            <div class=""> 
                                <pf-summery-front :pageurl="this.$api_url" :flg="c_flg"></pf-summery-front>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        
                        <template active v-slot:title>Members</template>                
                        <div class="clearfix">
                            <div class="">
                                <pf-signup-front :pageurl="this.$api_url" :flg="c_flg" v-on:childToParent="getAccountEmployees"></pf-signup-front>
                            </div>
                        </div>
                    </b-tab>
                    

                    <b-tab lazy>
                        <template active v-slot:title>Distribution</template>                
                        <div class="clearfix">
                            <div class="">
                                <pf-distribution-front :pageurl="this.$api_url" :flg="c_flg"></pf-distribution-front>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab lazy>
                        <template active v-slot:title>Profit Waiver</template>                
                        <div class="clearfix">
                            <div class="">
                                <pf-profit-waiver-list-front :pageurl="this.$api_url" :flg="c_flg"></pf-profit-waiver-list-front>
                            </div>
                        </div>
                    </b-tab>
    
                    <b-tab lazy>
                        <template active v-slot:title>Advances</template>                
                        <div class="clearfix">
                            <div class="">
                                <pf-loan-front :pageurl="this.$api_url" :flg="c_flg"></pf-loan-front>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>Deregistration</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <pf-de-registration-front :pageurl="this.$api_url" :flg="c_flg"  v-on:childToParent="getAccountEmployees"></pf-de-registration-front>
                            </div>
                        </div>
                    </b-tab>

                    <!-- <b-tab lazy>
                         <h4 class="mb-2 pb-2 border-bottom pb-2 mt-5">Documents</h4>
                        <p style="font-size: 15px; padding-bottom: 30px;">Deregister employees from provident fund. Process deregistration applications.</p>
                        <template active v-slot:title>Documents</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <PFDeRegistration :pageurl="this.$api_url" :flg="c_flg"  v-on:childToParent="getAccountEmployees"></PFDeRegistration>
                            </div>
                        </div>
                    </b-tab>
                     -->
                </template>
                
            </b-tabs>
        </div>
        <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
            <keep-alive>
                <search-employees :pageurl="this.$api_url" ></search-employees>
            </keep-alive>
        </b-modal>
    </div>
</div>
    </b-overlay>
</template>
<script> 
    
    export default{
        mounted() {
            this.setTabIndex();  
            //this.showoverlay = false;  
            //setTimeout(this.showContent , 3000);    
            
        },
        props: ['readonly','pageurl'],
        data(){            
            
            return {
                showoverlay : false,
                cu:window.location.href,
                ce : false,
                company_name:'',
                avatarsrc : null,
                employee_id : 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                company_pf_history:[{available_ff_fund:0,company_ff_fund:0}],
                pf_history_loading:true,

                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{
            
            showContent: function()
            {
                this.showoverlay = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                this.c_flg += 1;
            }, 
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },                        
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            getCompanyPFData: function(){
            let currentObj = this;
            let formData = new FormData();
            axios.post(this.$api_url+'/pf/get-company-pf-data', formData)
              .then(function (response) {
                 this.pf_history_loading = false; 
                 this.company_pf_history = response.data;
                 //this.company_pf_history.available_ff_fund = this.company_pf_history.company_ff_fund - this.company_pf_history.company_ff_distributed_amount - this.company_pf_history.total_distributed_reclaim;
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
         
            },
            getPFReportHeaderInfo: function(){
              axios.get(this.$api_url+'/pf/report/header') 
              .then(function (response) {
                 this.company_name = response.data.company_name;
                 
                 
              }.bind(this));
         
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);
                                
                            }                       
                                            

                    }.bind(this));                

            },
        },
        created: function(){
            //
            
            this.getAcl();
            this.getPFReportHeaderInfo();
            this.getCompanyPFData();
         
            //this.getEmployeeData();
            //this.setTabIndex();
        }

    }

</script>


<style>

.atlhr-pf-wizard  .reports-tab-nav-wrapper .nav-item .nav-link .btn-secondary {
	position: absolute;
	bottom: 10px !important;
}

.atlhr-pf-wizard .reports-tab-nav-wrapper .nav-item .nav-link {
	height: 160px !important;
	position: relative;
}
</style>